import { render } from "./submitTaskDialog.vue?vue&type=template&id=0681a04e&scoped=true"
import script from "./submitTaskDialog.vue?vue&type=script&lang=js"
export * from "./submitTaskDialog.vue?vue&type=script&lang=js"

import "./submitTaskDialog.vue?vue&type=style&index=0&id=0681a04e&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0681a04e"]])

export default __exports__